import API from '~/apis/client'

export async function get(productId: string, productItemId: string) {
  return await API.handle(
    API.public.get(
      `/public/v1/products/${productId}/product_items/${productItemId}`
    )
  )
}
